<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div >
        <!--PARTIE POURQUOI CHOISIR ASSURAF-->
        <div style="height: 100vh" class="bg-white">
                <div class="justify-content-center row pt-5">
                    <div class="justify-content-center column" style="width: 35%;padding-top:5% ;">
                        <h1 class="justify-content-center row titre_for_desktop">{{$t('plateforme_demo.title')}}</h1>
                         <div class="justify-content-center start">
              <v-toolbar class="ml-2 justify-content-center row underline_bar"></v-toolbar>
            </div>
                         <h1 class="justify-content-center row mt-5 titre_for_desktop_substitle">{{ $t('plateforme_demo.subtitle[0]') }} {{ $t('plateforme_demo.subtitle[1]') }}</h1>
                        <!-- <p class="title">Prenez contact avec notre équipe et réservez votre démonstration personnalisée dès aujourd’hui.</p> -->
                    </div>

                     <div class="form_container justify-content-center column ml-5" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);width: 43%;">
                        <div class="pa-3">
                            <div class="page">
                                <div>
                                    <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step1">
                                        <!-- Formulaire de Contact -->
                                        <div>
                                            <div>
                                                <div class="fields" style="background-color: #6b9dc1;">
                                                    <div class="row mt-3">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="name_input" class="field-label">{{ $t('plateforme_demo.form.nom_label') }} *</label>
                                                                <input v-model="scheduleDemoData.nom" :placeholder="$t('plateforme_demo.form.nom_placeholder')" id="name_input" name="Step1" class="field-input form-input-height">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nickname_input" class="field-label">{{ $t('plateforme_demo.form.prenom_label') }} *</label>
                                                                <input v-model="scheduleDemoData.prenom" :placeholder="$t('plateforme_demo.form.prenom_placeholder')" id="nickname_input" name="Step1" class="field-input form-input-height">
                                                            </div>
                                                        </div>
                                                    </div>

                                                     <div class="row mt-3">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="phone_number" class="field-label">{{ $t('plateforme_demo.form.number_label') }} *</label>
                                                                <div style="display: flex; align-items: center">
                                                                    <select v-model="scheduleDemoData.countryCode" class="field-select form-input-height" style="width: 50%;">
                                                                        <option v-for="item in intlNumberData" :key="item" :value="item.code">
                                                                            {{ item.flag }} {{ item.code }} <span v-if="selectOpen" class="select-helper">{{item.country}}</span>
                                                                        </option>
                                                                    </select>
                                                                    <input @keypress="onlyNumber" v-model="scheduleDemoData.num_telephone" :placeholder="$t('plateforme_demo.form.number_placeholder')" id="phone_number" name="Step1" class="ml-1 field-input form-input-height">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="name_entreprise" class="field-label">{{ $t('plateforme_demo.form.nom_entreprise_label') }} *</label>
                                                                <input v-model="scheduleDemoData.nom_entreprise" :placeholder="$t('plateforme_demo.form.nom_entreprise_placeholder')" id="name_entreprise" name="Step1" class="field-input form-input-height">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-3" v-if="scheduleDemoData.industrie == 'Autre'">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="autre_industrie_input" class="field-label">{{ $t('plateforme_demo.form.autre_industrie_label') }}  *</label>
                                                                <input v-model="scheduleDemoData.autre_industrie" :placeholder="$t('plateforme_demo.form.autre_industrie_placeholder')" id="autre_industrie_input" name="Step1" class="field-input form-input-height">
                                                            </div>
                                                        </div>
                                                    </div>

                                                     <div class="row mt-3">
                                                         <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="industrie_input" class="field-label">{{ $t('plateforme_demo.form.industrie_label') }} *</label>
                                                                 <select v-model="scheduleDemoData.industrie" id="industrie_input" name="Step1" class="field-select form-input-height">
                                                                    <option value="Activite_financiere">Activités financières</option>
                                                                    <option value="Courtier_assurance">Courtier d'assurance</option>
                                                                    <option value="Compagnie_assurance">Compagnie d'assurance</option>
                                                                    <option value="Intermediaire_assurance">Intermédiaire d'assurance</option>
                                                                    <option value="Commerce_gros_detail">Commerce de gros et de détail</option>
                                                                    <option value="Transport_logistique">Transports et logistique</option>
                                                                    <option value="Telecommunication">Télécommunications</option>
                                                                    <option value="Informatique_numerique">Informatique et numérique</option>
                                                                    <option value="Tourisme_hotellerie">Tourisme et hôtellerie</option>
                                                                    <option value="Service_entreprise">Services aux entreprises</option>
                                                                    <option value="Autre">Autres</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="fonction_input" class="field-label">{{ $t('plateforme_demo.form.fonction_label') }} *</label>
                                                                 <select v-model="scheduleDemoData.fonction" id="fonction_input" name="Step1" class="field-select form-input-height">
                                                                    <optgroup label="Direction">
                                                                        <option value="PDG">PDG</option>
                                                                        <option value="DG">DG</option>
                                                                        <option value="CEO">CEO</option>
                                                                        <option value="CFO">CFO – Directeur financier</option>
                                                                        <option value="COO">COO – Directeur des opérations</option>
                                                                        <option value="CIO">CIO – DSI</option>
                                                                        <option value="CMO">CMO – Directeur marketing</option>
                                                                        <option value="Hr_directeur">HR Director – DRH</option>
                                                                    </optgroup>
                                                                    <optgroup label="Manangement & Support">
                                                                        <option value="Directeur_commercial">Directeur commercial</option>
                                                                        <option value="Business_developpeme_mananger">Business Development Manager</option>
                                                                        <option value="Chef_projet">Chef de projet</option>
                                                                        <option value="compliance_officer">Chief Compliance Officer</option>
                                                                        <option value="risk_officer">Chief Risk Officer</option>
                                                                    </optgroup>
                                                                    <optgroup label="Stratégie & Cabinet">
                                                                        <option value="Directeur_cabinet">Directeur de cabinet</option>
                                                                        <option value="Chef_cabinet">Chef de cabinet</option>
                                                                        <option value="Charge_mission">Chargé de mission</option>
                                                                        <option value="Charge_affaires">Chargé d’affaires</option>
                                                                    </optgroup>
                                                                    <optgroup label="Opérationnelle">
                                                                        <option value="Chef_produit">Chef de produit</option>
                                                                        <option value="Coordinateur_projet">Coordinateur de projet</option>
                                                                        <option value="Responsable_logistique">Responsable logistique</option>
                                                                        <option value="Responsable_communication">Responsable communication</option>
                                                                        <option value="Responsable_paie">Responsable paie</option>
                                                                        <option value="Responsable_audit_interne">Responsable audit interne</option>
                                                                    </optgroup>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                      <div class="row mt-3">
                                                         <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="country_input" class="field-label">{{ $t('plateforme_demo.form.pays_label') }} *</label>
                                                                 <select v-model="scheduleDemoData.pays" id="country_input" name="Step1" class="field-select form-input-height">
                                                                    <option v-for="(item, index) in listCountry" :key="index" :value="item.PAYS">{{item.PAYS}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="how_you_know_input" class="field-label">{{ $t('plateforme_demo.form.how_to_know_assuraf_label') }} *</label>
                                                                <select v-model="scheduleDemoData.where_you_know" id="how_you_know_input" name="Step1" class="field-select form-input-height">
                                                                    <option value="Google">Google</option>
                                                                    <option value="LinkedIn">LinkedIn</option>
                                                                    <option value="Facebook">Facebook</option>
                                                                    <option value="X (Twitter)">X (Twitter)</option>
                                                                    <option value="Évenement">Évenement</option>
                                                                    <option value="Ami">Ami(s)</option>
                                                                    <option value="Collegue">Collégue</option>
                                                                    <option value="Publicite">Publicité</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-3">
                                                         <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="message_input" class="field-label">{{ $t('plateforme_demo.form.message_label') }} *</label>
                                                                <textarea v-model="scheduleDemoData.message" id="message_input" :placeholder="$t('plateforme_demo.form.message_placeholder')" rows="1" style="height: 80px; width: 100%; resize: vertical; border-radius: 10px; padding: 10px; background-color: #fff; color: #000; border: 1px solid #e5e5e5; font-size: 16px;"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <p class="mt-3">
                                                        <span style="color: red;">*</span> {{ $t('plateforme_demo.form.champ_obligatoire_label') }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix mb-4">
                                  
                                    <div class="wizard-footer-right">
                                        <button type="button" @click="openScheduleData()"  class="wizard-btn mt-3">
                                            {{ $t('plateforme_demo.form.bouton_envoye_label') }}
                                        </button>
                                    </div>
                                      <div class="wizard-footer-left">
                                    </div>
                                    <!---->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

          <!-- <div style="background-color: red; height:350px!important" class="ml-3">
            <p>test</p>
          </div> -->
            </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <div>
        <div style="background: #ffffff;height: auto;margin-bottom: 5%;padding-top:20% ;">
          <div class="justify-content-center column pt-5 pb-4">
            <div class="justify-content-center row ml-2 mr-2">
                <h1 class="justify-content-center row titre_for_desktop_mobile">{{ $t('plateforme_demo.title') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="justify-content-center row pt-5 mr-4 ml-4">
                <h1 class="justify-content-center row titre_for_desktop_substitle_mobile">{{ $t('plateforme_demo.subtitle[0]') }} {{ $t('plateforme_demo.subtitle[1]') }}</h1>
            </div>
          </div>

            <div class="form_container_mobile justify-content-center column ml-4 mr-4" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);">
                <div class="pa-3">
                    <div class="page">
                        <div>
                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step1">
                                <!-- Formulaire de Contact -->
                                <div>
                                    <div>
                                        <div class="fields" style="background-color: #6b9dc1;">
                                            <div class="row mt-3">
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="name_input_mobile" class="field-label">{{ $t('plateforme_demo.form.nom_label') }} *</label>
                                                        <input v-model="scheduleDemoData.nom" :placeholder="$t('plateforme_demo.form.nom_placeholder')" id="name_input_mobile" name="Step1" class="field-input">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="nickname_input_mobile" class="field-label">{{ $t('plateforme_demo.form.prenom_label') }} *</label>
                                                        <input v-model="scheduleDemoData.prenom" :placeholder="$t('plateforme_demo.form.prenom_placeholder')" id="nickname_input_mobile" name="Step1" class="field-input">
                                                    </div>
                                                </div>

                                                 <div class="col-sm-12">
                                                     <div class="field-group field-default mb-4 mb-sm-0">
                                                    <label for="phone_number" class="field-label">{{ $t('plateforme_demo.form.number_label') }} *</label>
                                                     <div style="display: flex; align-items: center">
                                                                    <select v-model="scheduleDemoData.countryCode" class="field-select" style="width: 47%;">
                                                                        <option v-for="item in intlNumberData" :key="item" :value="item.code">
                                                                            {{ item.flag }} {{ item.code }} <span v-if="selectOpen" class="select-helper">{{item.country}}</span>
                                                                        </option>
                                                                    </select>
                                                                    <input @keypress="onlyNumber" v-model="scheduleDemoData.num_telephone" :placeholder="$t('plateforme_demo.form.number_placeholder')" id="phone_number" name="Step1" class="ml-1 field-input">
                                                                </div>
                                                    <!-- <div class="ml-4" style="display: flex; align-items: center; width: 47%;">
                                                         <select v-model="scheduleDemoData.countryCode" class="intl_number_mobile">
                                                        <option v-for="item in intlNumberData" :key="item" :value="item.code">
                                                            {{ item.flag }} {{ item.code }} <span v-if="selectOpen" class="select-helper">{{item.country}}</span>
                                                        </option>
                                                    </select>
                                                    <span style="margin-left: -20px;margin-top: -5px; pointer-events: none; color: black; font-size: 10px;">&#9660;</span>

                                                    <input v-model="scheduleDemoData.num_telephone" :placeholder="$t('plateforme_demo.form.number_placeholder')" id="phone_number" name="Step1" class="field-input">
                                                    </div> -->
                                                </div>
                                                </div>
                                            </div>

                                              <div class="row mt-2">
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="name_entreprise_mobile" class="field-label">{{ $t('plateforme_demo.form.nom_entreprise_label') }} *</label>
                                                        <input v-model="scheduleDemoData.nom_entreprise" :placeholder="$t('plateforme_demo.form.nom_entreprise_placeholder')" id="name_entreprise_mobile" name="Step1" class="field-input">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="industrie_input_mobile" class="field-label">{{ $t('plateforme_demo.form.industrie_label') }} *</label>
                                                          <select v-model="scheduleDemoData.industrie" id="industrie_input_mobile" name="Step1" class="field-select">
                                                            <option value="Activite_financiere">Activités financières</option>
                                                            <option value="Courtier_assurance">Courtier d'assurance</option>
                                                            <option value="Compagnie_assurance">Compagnie d'assurance</option>
                                                            <option value="Intermediaire_assurance">Intermédiaire d'assurance</option>
                                                            <option value="Commerce_gros_detail">Commerce de gros et de détail</option>
                                                            <option value="Transport_logistique">Transports et logistique</option>
                                                            <option value="Telecommunication">Télécommunications</option>
                                                            <option value="Informatique_numerique">Informatique et numérique</option>
                                                            <option value="Tourisme_hotellerie">Tourisme et hôtellerie</option>
                                                            <option value="Service_entreprise">Services aux entreprises</option>
                                                            <option value="Autre">Autres</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-2" v-if="scheduleDemoData.industrie == 'Autre'">
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="autre_industrie_input_mobile" class="field-label">{{ $t('plateforme_demo.form.autre_industrie_label') }} *</label>
                                                        <input v-model="scheduleDemoData.autre_industrie" :placeholder="$t('plateforme_demo.form.autre_industrie_placeholder')" id="autre_industrie_input_mobile" name="Step1" class="field-input">
                                                    </div>
                                                </div>
                                            </div>

                                              <div class="row mt-2">
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="fonction_input_mobile" class="field-label">{{ $t('plateforme_demo.form.fonction_label') }} *</label>
                                                          <select v-model="scheduleDemoData.fonction" id="fonction_input_mobile" name="Step1" class="field-select">
                                                            <optgroup label="Direction">
                                                                <option value="PDG">PDG</option>
                                                                <option value="DG">DG</option>
                                                                <option value="CEO">CEO</option>
                                                                <option value="CFO">CFO – Directeur financier</option>
                                                                <option value="COO">COO – Directeur des opérations</option>
                                                                <option value="CIO">CIO – DSI</option>
                                                                <option value="CMO">CMO – Directeur marketing</option>
                                                                <option value="Hr_directeur">HR Director – DRH</option>
                                                            </optgroup>
                                                            <optgroup label="Manangement & Support">
                                                                <option value="Directeur_commercial">Directeur commercial</option>
                                                                <option value="Business_developpeme_mananger">Business Development Manager</option>
                                                                <option value="Chef_projet">Chef de projet</option>
                                                                <option value="compliance_officer">Chief Compliance Officer</option>
                                                                <option value="risk_officer">Chief Risk Officer</option>
                                                            </optgroup>
                                                            <optgroup label="Stratégie & Cabinet">
                                                                <option value="Directeur_cabinet">Directeur de cabinet</option>
                                                                <option value="Chef_cabinet">Chef de cabinet</option>
                                                                <option value="Charge_mission">Chargé de mission</option>
                                                                <option value="Charge_affaires">Chargé d’affaires</option>
                                                            </optgroup>
                                                            <optgroup label="Opérationnelle">
                                                                <option value="Chef_produit">Chef de produit</option>
                                                                <option value="Coordinateur_projet">Coordinateur de projet</option>
                                                                <option value="Responsable_logistique">Responsable logistique</option>
                                                                <option value="Responsable_communication">Responsable communication</option>
                                                                <option value="Responsable_paie">Responsable paie</option>
                                                                <option value="Responsable_audit_interne">Responsable audit interne</option>
                                                            </optgroup>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="country_input_mobile" class="field-label">{{ $t('plateforme_demo.form.pays_label') }}  *</label>
                                                          <select v-model="scheduleDemoData.pays" id="country_input_mobile" name="Step1" class="field-select">
                                                            <option v-for="(item, index) in listCountry" :key="index" :value="item.PAYS">{{item.PAYS}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                              <div class="row mt-2">
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="how_you_know_input_mobile" class="field-label">{{ $t('plateforme_demo.form.how_to_know_assuraf_label') }}  *</label>
                                                        <select v-model="scheduleDemoData.where_you_know" id="how_you_know_input_mobile" name="Step1" class="field-select">
                                                            <option value="Google">Google</option>
                                                            <option value="LinkedIn">LinkedIn</option>
                                                            <option value="Facebook">Facebook</option>
                                                            <option value="X (Twitter)">X (Twitter)</option>
                                                            <option value="Évenement">Évenement</option>
                                                            <option value="Ami">Ami(s)</option>
                                                            <option value="Collegue">Collégue</option>
                                                            <option value="Publicite">Publicité</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="message_input_mobile" class="field-label">{{ $t('plateforme_demo.form.message_label') }} *</label>
                                                        <textarea v-model="scheduleDemoData.message" id="message_input_mobile" :placeholder="$t('plateforme_demo.form.message_placeholder')" rows="1" style="height: 100px; width: 100%; resize: vertical; border-radius: 10px; padding: 15px; background-color: #fff; color: #000; border: 1px solid #e5e5e5; font-size: 16px;"></textarea>
                                                    </div>
                                                </div>
                                            </div>

                                            <p class="mt-2">
                                                <span style="color: red;">*</span> {{ $t('plateforme_demo.form.champ_obligatoire_label') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix mb-4">
                          
                            <div class="wizard-footer-right">
                                <button type="button" @click="openScheduleData()"  class="wizard-btn mt-3">
                                    {{ $t('plateforme_demo.form.bouton_envoye_label') }}
                                </button>
                            </div>
                              <div class="wizard-footer-left">
                            </div>
                            <!---->
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import { countryController } from '../../packages/country/country.controller';
import dayjs from 'dayjs';
import Api from '../../services/Api';
import IntlNumber from '../../common/intlNumber.json'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    }
};

export default {
  name: 'schedule_demo',
  components: {
    simplebar
  },
  data: () => ({
    errors: {},
    intlNumberData: IntlNumber,
    calendlyLink: 'https://calendly.com/sougning/demo-assur-cloud',
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    listCountry: [],
    dateschedule:null,
    finishedScheduleCalendly : false,
    scheduleDemoData : {
        nom : null,
        prenom : null,
        num_telephone : null,
        nom_entreprise : null,
        industrie : null,
        autre_industrie : null,
        fonction : null,
        pays : null,
        where_you_know : null,
        message: null,
        countryCode : '+221'

    },
    ToastTabSucess: { // Customized options for success toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
    },
    ToastTabError: { // Customized options for error toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'error'
    },
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },
  methods : {
    /*=============Filtre sans le + sur le input telephone de la creation de compte ===========*/
    onlyNumber($event) {
        let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
            $event.preventDefault();
        }
    },

    clearScheduleDataForm(){
        this.scheduleDemoData.nom = '',
        this.scheduleDemoData.prenom = '',
        this.scheduleDemoData.nom_entreprise = '',
        this.scheduleDemoData.industrie = null,
        this.scheduleDemoData.autre_industrie = '',
        this.scheduleDemoData.fonction = null,
        this.scheduleDemoData.pays = null,
        this.scheduleDemoData.where_you_know = null,
        this.scheduleDemoData.message = ''
    },
    openCalendlyDemo() {
      Calendly.initPopupWidget({
        url: 'https://calendly.com/sougning/demo-assur-cloud'
      });
    },

    sendScheduleData(){
        const scheduleData = {
            nom : this.scheduleDemoData.nom,
            prenom : this.scheduleDemoData.prenom,
            num_telephone : (this.scheduleDemoData.countryCode+this.scheduleDemoData.num_telephone).substring(1),
            nom_entreprise : this.scheduleDemoData.nom_entreprise,
            industrie : this.scheduleDemoData.industrie,
            autre_industrie : this.scheduleDemoData.autre_industrie,
            fonction : this.scheduleDemoData.fonction,
            pays : this.scheduleDemoData.pays,
            where_you_know : this.scheduleDemoData.where_you_know,
            message: this.scheduleDemoData.message
        }

        if(this.scheduleDemoData.industrie != 'Autre') {
            scheduleData.autre_industrie = 'N.A'
        }

        Api().post('message/demo', scheduleData)
            .then(response => {
                if (response.data.info == 'ok'){
                    this.$toasted.show('Demande de demo transmise. Nous vous répondons très bientôt', this.ToastTabSucess);
                    this.clearScheduleDataForm()
                    setTimeout(() => (window.location.reload()), 3000)
                } else {
                    this.$toasted.show('L\'envoi du message a échoué veuillez réessayer', this.ToastTabError)
                }
            })
    },
    
    openScheduleData (){
        if(this.scheduleDemoData.nom && this.scheduleDemoData.prenom){
            if(this.scheduleDemoData.nom_entreprise && this.scheduleDemoData.industrie){
                if(this.scheduleDemoData.fonction && this.scheduleDemoData.pays){
                    if(this.scheduleDemoData.where_you_know && this.scheduleDemoData.message){
                        if(this.scheduleDemoData.industrie == 'Autre'){
                            if(this.scheduleDemoData.autre_industrie){
                                const validPhone = validatePhoneWithIndicatif(this.scheduleDemoData.num_telephone, this.scheduleDemoData.countryCode);
                                this.errors.phone = validPhone.error;
                                if(validPhone.valid == true){
                                     this.openCalendlyDemo()
                                }else {
                                    this.$toasted.show("Le numéro n'est pas valide pour l'indicatif sélectionné !", this.ToastTabError)
                                }
                            }else {
                                this.$toasted.show("Le champ 'autre industrie' est obligatoire !", this.ToastTabError)
                            }
                        }else {
                            const validPhone = validatePhoneWithIndicatif(this.scheduleDemoData.num_telephone, this.scheduleDemoData.countryCode);
                            this.errors.phone = validPhone.error;
                            if(validPhone.valid == true){
                                this.scheduleDemoData.autre_industrie = null
                                this.openCalendlyDemo()
                            }else {
                                this.$toasted.show("Le numéro n'est pas valide pour l'indicatif sélectionné !", this.ToastTabError)
                            }
                        }
                }else {
                    this.$toasted.show("Les champs 'Comment avez vu connu Assuraf' et 'message' sont obligatoires !", this.ToastTabError)
                }
                }else {
                    this.$toasted.show("Les champs fonction et pays sont obligatoires !", this.ToastTabError)
                }
            }else {
                this.$toasted.show("Les champs nom d'entreprise et industrie sont obligatoires !", this.ToastTabError)
            }
        }else (
            this.$toasted.show("Les champs nom et prénom sont obligatoires !", this.ToastTabError)
        )
    },

    disabledAfterToday(date) {
        const today = dayjs(new Date()).add(-1, 'day')
        return date < today;
    },

    async getListCountry() {
            try {
                const country = await countryController
                this.listCountry = country.data
            } catch (error) {
                console.log("Error : ", error)   
            }
      }
  },
  mounted() {
   window.addEventListener('message', function(e) {
    if (e.origin === 'https://calendly.com' && e.data.event && e.data.event === 'calendly.event_scheduled') {

      this.sendScheduleData();
        // An event has been scheduled.
        // e.data.payload will contain details about the scheduled event.
        //console.log('Calendly event scheduled:', e.data.event);
        // You can now trigger custom actions, like sending analytics, updating your UI, etc.
    } 
}.bind(this));

  window.scrollTo(0, 0);
  this.getListCountry()
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

 ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
    }

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #6b9dc1!important;
  font-size: 6rem;
  font-weight: bold;
  text-align:start;
  text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 1px 2px rgba(0, 0, 0, .3), 0 3px 9px rgba(0, 0, 0, .1);
}
.titre_for_desktop_mobile {
  color: #5B94BC;
  font-size: 3rem;
  font-weight: bold;
  text-align:center;
  text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 1px 2px rgba(0, 0, 0, .3), 0 3px 9px rgba(0, 0, 0, .1);
}
.titre_for_desktop_substitle{
  color: #000;
  font-size: 3rem;
  font-weight: 300;
  text-align:start;
    text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 1px 2px rgba(0, 0, 0, .3), 0 3px 9px rgba(0, 0, 0, .1);
}

.titre_for_desktop_substitle_mobile{
  color: #000;
  font-size: 2rem;
  font-weight: 300;
  text-align:center;
    text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 1px 2px rgba(0, 0, 0, .3), 0 3px 9px rgba(0, 0, 0, .1);

}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}


h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}


html {
background: #292929;
color: #edebeb;
padding: 1rem;
}

.field-default .field-label {
    color: #000000;
    font-weight: 400;
}

.form_container {
  background-color: #6b9dc1;
  width: 44%;
  border-radius: 20px;
  margin-top: 5%;
}

.form_container_mobile {
  //background-color: #bed6e6;
  background-color: #6b9dc1;
  //width: 40%;
  border-radius: 20px;
  //margin-top: 4%;
}

.form-input-height {
    height: 45px!important;
    border-radius: 10px
}

.intl_number {
   border-radius: 30px 0 0 30px;
   height: 40px;
   background: #FFF; 
   color: black;
   margin-top:-5px!important;
   font-size: 14px;

}
.intl_number:hover {
    border: 1.5px solid #000000;
}
.intl_number:focus {
    outline: none;
    border-color: #F99B00 !important;
}
    .intl_number:focus::-webkit-input-placeholder {
        color: #000;
    }
    .intl_number:focus::-moz-placeholder {
        color: #000;
    }
    .intl_number:focus:-ms-input-placeholder {
        color: #000;
    }
    .intl_number:focus::-ms-input-placeholder {
        color: #000;
    }

.intl_number::-webkit-input-placeholder {
    color: #000;
}


.intl_number_mobile {
   border-radius: 30px 0 0 30px;
   height: 36px;
   background: #F99B00; 
   color: black;
   margin-top:-5px!important;
   font-size: 12px;

}
.intl_number_mobile:hover {
    border: 1.5px solid #000000;
}
.intl_number_mobile:focus {
    outline: none;
    border-color: #F99B00 !important;
}
    .intl_number_mobile:focus::-webkit-input-placeholder {
        color: #000;
    }
    .intl_number_mobile:focus::-moz-placeholder {
        color: #000;
    }
    .intl_number_mobile:focus:-ms-input-placeholder {
        color: #000;
    }
    .intl_number_mobile:focus::-ms-input-placeholder {
        color: #000;
    }

.intl_number_mobile::-webkit-input-placeholder {
    color: #000;
}

</style>

